/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import * as commonFun from '@editor/src/page/index/components/canvas/common';
import connect from '@src/js/separate-logic/connect';
import _has from 'lodash/has';
import styles from './index.css';
import GroupElementModel from './group-element-model';
import GroupElementWrapper from '@editor/src/page/index/components/canvas/group-element-wrapper';
import GroupElementPresenter from './group-element-presenter';
import { CommonContainer } from '@src/js/service/component-service/commonContainer';
import { isAudioElement, isGroupModel, isVideoElement, isDomCompatibleElement, isGroupHasDomCompatibleElement } from '@src/slide/domain/ui-model/elements/element-judge';
import { RenderPostionType } from '@src/js/constant';

interface IGroupElementProps{
    setRef: (name: string, ref: any) => void;
    rect: any;
    component: any;
    renderChild: () => any;
    getSize: () => any;
    getFlip: () => any;
    handleBorderMouseDown: () => void;
    relativeFlipH: number;
    relativeFlipV: number;
    elementRootId: string;
    getPageScale: () => number;
    fromScale: number;
    region: string;
    handleMouseDown: () => void;
    handleMouseUp: () => void;
    rotate: number;
    relativeRotate: number;
    onElementUpdate: () => void;
    taskGroup: any;
    event: any;
    sync: any;
    mobileEditMode: () => boolean;
}

@observer
class GroupElement extends Component<IGroupElementProps> {
    public static defaultProps = {
        setRef: () => {},
        handleMouseDown: () => {},
        handleMouseUp: () => {},
    };

    /* eslint-disable complexity */
    public render() {
        const { setRef, rect, component } = this.props;
        const width = rect ? rect.width : component.props.style.width;
        const height = rect ? rect.height : component.props.style.height;
        const flip = {
            flipH: this.props.rect ? this.props.rect.flipH : (_has(component.props, 'style.flipH') ? component.props.style.flipH : 0),
            flipV: this.props.rect ? this.props.rect.flipV : (_has(component.props, 'style.flipV') ? component.props.style.flipV : 0),
        };
        const frame = {
            width,
            height,
        };

        return (
            <CommonContainer
                type={'div'}
                id="group"
                ref={ref => setRef('contentRef', ref)}
                className={styles.group}
                style={{
                    ...frame,
                    // position: 'absolute', 去除无用position，减少回流时间
                    transformOrigin: null,
                    transform: commonFun.transformOfFlip(flip),
                }}>
                {component?.children.map(this.renderChild)}
            </CommonContainer>
        );
    }
    private renderChild = (childObj, i) => {
        if (!childObj.rendered) {
            // eslint-disable-next-line no-param-reassign
            childObj.rendered = true;
        }

        if (
            // 非 dom 兼容元素
            !isDomCompatibleElement(childObj)
            // 若是组合元素，查看里面是否有 dom 兼容元素
            && !(isGroupModel(childObj) && isGroupHasDomCompatibleElement(childObj))
        ) {
            return null;
        }
        /**
         * 编辑态或演示态中缩略图里面的音视频元素不显示 dom 版本，因为本来也不需要播放，而且 canvas 截图里面也有对应的占位图
         */
        if (isVideoElement(childObj) || isAudioElement(childObj)) {
            const { region } = this.props;
            // 移动端编辑态缩略图
            const isEditModeThumbnail = region === RenderPostionType.MOBILEBROWSE && this.props.mobileEditMode?.();
            // 移动端演示态缩略图
            const isMobilePlayerThumbnail = region === RenderPostionType.MOBILE_PLAYER_THUMBNAIL;
            if (isEditModeThumbnail || isMobilePlayerThumbnail) {
                return;
            }
        }

        const shouldUpdate = !childObj.rendered;

        let { relativeFlipH } = this.props;
        let { relativeFlipV } = this.props;

        if (this.props.component.props.style.flipH === 1) {
            relativeFlipH = (relativeFlipH === 0 ? 1 : 0);
        }
        if (this.props.component.props.style.flipV === 1) {
            relativeFlipV = (relativeFlipV === 0 ? 1 : 0);
        }

        return this.getGroupElementWrapper(childObj, i, shouldUpdate, relativeFlipH, relativeFlipV);
    };
    private getGroupElementWrapper = (
        childObj,
        i,
        shouldUpdate,
        relativeFlipH,
        relativeFlipV,
    ) => (<GroupElementWrapper
        ref={ref => this.props.setRef(childObj.key, ref)}
        shouldUpdate={shouldUpdate}
        key={childObj.key}
        elementRootId={this.props.elementRootId}
        scale={this.props.getPageScale()}
        getPageScale={this.props.getPageScale}
        component={childObj}
        elementIndex={i}
        fromScale={this.props.fromScale}
        region={this.props.region}
        handleMouseDown={this.props.handleMouseDown}
        handleMouseUp={this.props.handleMouseUp}
        relativeRotate={((this.props.rotate ? this.props.rotate : 0) + this.props.relativeRotate) % 360}
        relativeFlipH={relativeFlipH}
        relativeFlipV={relativeFlipV}
        onElementUpdate={this.props.onElementUpdate}
        taskGroup={this.props.taskGroup}
        event={this.props.event}
        sync={this.props.sync}
    />);
}

export default connect(
    GroupElementPresenter,
    GroupElementModel,
    GroupElement,
);
